export const prepareBody = (requestProfile) => {
    const mapProfile = new Map(Object.entries(requestProfile));

    if (mapProfile.has("acceptFreelanceWork")) {
      requestProfile.acceptFreelanceWork =
        mapProfile.get("acceptFreelanceWork").toLowerCase() === "yes";
    }

    if (mapProfile.has("skills")) {
      requestProfile.skills = mapProfile.get("skills").split(",");
    }

    for (const [key, value] of mapProfile) {
      if (!value || !value.trim()) {
        delete requestProfile[key];
      }
    }
    return requestProfile;
  };